import { useIntl } from 'react-intl';
import { getCountryCode3, booleanFilter, getMembershipsToShow } from '~/shared/utils';
import { Queries } from '~/graphql';
import { useUserContext } from '~/shared/contexts';

export const useAvailableMemberships = () => {
    const { locale } = useIntl();
    const { data, loading, error } = Queries.useGetMembershipsQuery({
        variables: { country: getCountryCode3(locale) }
    });
    const userContext = useUserContext();
    const occupationType = userContext.user?.occupationType;

    const allMemberships = (data?.memberships || []).filter(booleanFilter);
    const allowedMemberships = occupationType
        ? getMembershipsToShow(allMemberships, occupationType && [occupationType])
        : [];

    return { allMemberships, allowedMemberships, loading, error };
};
